import {chain} from "@Common/utils/fs";

export const inSize = (p, size) => ({
    x: chain(
        p.x,
        (_) => Math.max(0, _),
        (_) => Math.min(size.width, _),
    ),
    y: chain(
        p.y,
        (_) => Math.max(0, _),
        (_) => Math.min(size.height, _),
    ),
});
